import React, { createContext, useContext } from "react";
import { ASResponse, SearchResponse } from "types/searchApi/response";

export interface GlobalContext {
  initData: SearchResponse | ASResponse | null;
  closeModal: () => void;
  getResults: (
    searchTerm?: string,
  ) => Promise<SearchResponse | ASResponse | null>;
  brand: string;
}

const GlobalContext = createContext<GlobalContext>({} as GlobalContext);
GlobalContext.displayName = "ASGlobalContext";

export const GlobalContextProvider = React.memo(GlobalContext.Provider);

const useGlobalContext = () => {
  return useContext(GlobalContext);
};

export default useGlobalContext;
